module.exports = __webpack_public_path__ + "static/media/ceilings_allImpact_60yd_n.2ab6643e.csv";